import React from 'react'

const Varibales = () => {
    return (
        <div className='container'>
            <h1>Python Variables</h1>
         <p>Python is not “statically typed”. We do not need to declare variables before
              using them or declare their type. A variable is created the moment we first
               assign a value to it. A variable is a name given to a memory location. It
                is the basic unit of storage in a program.</p>   
                <ol>
                    <li style={{listStyle:'disc'}}>The value stored in a variable can be changed during program execution.</li>
                    <li style={{listStyle:'disc'}}>A variable is only a name given to a memory location, all the operations done on the variable effects that memory location.</li>
                </ol>
                <h3>Rules for creating variables in Python:</h3>
                <ol>
                    <li style={{listStyle:'disc'}}>A variable name must start with a letter or the underscore character.</li>
                    <li style={{listStyle:'disc'}}>A variable name cannot start with a number.</li>
                    <li style={{listStyle:'disc'}}>A variable name can only contain alpha-numeric characters and underscores (A-z, 0-9, and _ ).</li>
                    <li style={{listStyle:'disc'}}>Variable names are case-sensitive (name, Name and NAME are three different variables).</li>
                    <li style={{listStyle:'disc'}}>The reserved words(keywords) cannot be used naming the variable.</li>
                </ol>
                <h3><strong>Let’s see the simple variable creation:</strong></h3>
         <div className='containers'>
                <br />
<code className='comment'># A string</code><br />
<code className='keywords'> college</code> = "SAITM"<br />
<br />
<code className='comment'> # An integer assignment</code> <br />

<code className='keywords'>rank</code> = 1<br />
<br />
<code className='comment'># A floating point</code><br />

<code className='keywords'>percentage</code> = 99.9%<br />
<br />
<code className='library'>print</code>(college)<br />
<code className='library'>print</code>(rank)<br />
<code className='library'>print</code>(percentage)<br />
<br />
</div>
<div className='output'>
    <h3>Output:</h3>
    SAITM <br /> 1 <br /> 99.9% <br />
</div>
<h3> Declare the Variable</h3>
<div className='containers'>
<code className='comment'># declaring the var</code> <br />
<code className='keywords'>Number</code> = 100 <br />
  <br />
  <code className='comment'># display</code> <br />
  <code className='library'>print</code>( Number) <br />
</div>
<h3>Output: <br /> </h3>
   <div className='output'>
   100

   </div>
   <h3>Re-declare the Variable:</h3>
   <div className='containers'>
   <code className='comment'> # declaring the var</code> <br />
   <code className='keywords'> Number</code> = 100<br />
<br />
<code className='comment'># display </code><br />
<code className='library'>print</code>("Before declare: ", Number)<br />
<br />
<code className='comment'># re-declare the var</code><br />
<code className='keywords'>Number</code> = 120.3<br />
<br />
<code className='library'>print</code>("After re-declare:", Number)<br />
<br />
   </div>
   <h3>Output:</h3> <br />
   <div className='output'>
   Before declare:  100 <br />
After re-declare: 120.3 <br />
   </div>
   <h3>Assigning a single value to multiple variables: </h3>
   <div className='containers'>

   <code className='keywords'>a </code>= <code className='keywords'>b</code> =<code className='keywords'> c</code> = 10

   <code className='library'>print</code>(a)
   <code className='library'>print</code>(b)
   <code className='library'>print</code>(c)
   </div>
   <h3>Output:</h3>
   <div className='output'>
   10 <br />
10 <br />
10 <br />
   </div>
   <h3>Assigning different values to multiple variables:</h3>
   <div className='containers'>
   

   <code className='keywords'>a</code>,<code className='keywords'> b</code>, <code className='keywords'>c</code> = 1, 20.2, "NooB-Geeks" <br />
   <br />
   <code className='library'>print</code>(a) <br />
   <code className='library'>print</code>(b) <br />
   <code className='library'>print</code>(c) <br />
 </div>
 <h3>Output:</h3>
 <div className='output'>
 1 <br />
20.2 <br />
NooB-Geeks <br />
 </div>
 <div>
 <h3>Can we use the same name for different types? </h3>
 <div className='containers'>
 <code className='keywords'> a</code> = 10 <br />
 <code className='keywords'>a </code>= "NooB-Geeks" <br />
   <code className='library'>print</code>(a)<br /></div>
 
       </div>
       <h3>Output:</h3>
       <div className='output'>
       NooB-Geeks
       </div>
<h3>How does + operator work with variables? </h3>
<div className='containers'>
<br />
<code className='keywords'></code>a = 10 <br />
<code className='keywords'></code>b = 20 <br />
print(a+b) <br />
 <br />
 <code className='keywords'>a </code>= "NooB" <br />
 <code className='keywords'>b </code>= "Geeks" <br />
 <code className='library'>print</code>(a+b) <br />

</div>
<h3>Output</h3>
<div className='containers'>
30 <br />
NooBGeeks <br />
</div>
<h3>Can we use + for different types also? </h3>
<div className='containers'>
<code className='keywords'>a</code> = 10 <br />
<code className='keywords'>b</code> = "Geeks" <br />
<code className='library'>print</code>(a+b) <br />
</div>
<h3>Output : </h3>
<div className='output'>
TypeError: unsupported operand type(s) for +: 'int' and 'str'
</div>
<h3>Global and Local Variables in Python:</h3>
<b> Local variables</b> are the ones that are defined and declared inside a function. We can not call this variable outside the function
<div className='containers'>
<code className='keywords'># This function uses global variable</code> <br />
<code className='library'>def f</code>(): <br />
<code className='keywords'>a</code> = "Welcome NooBies" <br />
<code className='library'>print(a)</code> <br />


f()

</div>
<h3>Output:</h3>
<div className='output'>
Welcome NooBies
</div>
<b>Global variables </b>are the ones that are defined and declared outside a function, and we need to use them inside a function.
<div className='containers'>
<code className='comment'># This function has a variable with </code><br />
<code className='comment'># name same as s. </code><br />
<code className='library'>def</code> f(): <br />
<code className='library'>	print</code>(s)  <br /> <br /> <br />
<code className='comment'># Global scope</code> <br />
s = "I love NooBies" <br />
f() <br />
</div>
<h3>Output:</h3>
<div className='output'>
I love NooBies
</div>
<h3>Variable type in Python:</h3>
Data types are the classification or categorization of data items. It represents the kind of value that tells what operations can be performed on a particular data. Since everything is an object in Python programming, data types are actually classes and variables are instance (object) of these classes.
<br /> <br />
<div className='containers'>
Following are the standard or built-in data type of Python: <br />
<ol>
    <li>Numeric</li>
    <li>Sequence Type</li><li>Boolean</li><li>Set</li><li>Dictionary</li>
</ol>
Later we will see these topics</div>
        </div>
    )
}

export default Varibales
